/**
 * DSE score → points and competitiveness percentages (shared with JUPASelect).
 */

export function scoreToPoints(rawScore) {
  if (!rawScore) return 0;
  const s = String(rawScore).trim();

  if (s === '5**') return 7;
  if (s === '5*') return 6;
  if (s === '5') return 5;
  if (s === '4') return 4;
  if (s === '3') return 3;
  if (s === '2') return 2;
  if (s === '1') return 1;

  const numericMatch = s.match(/^(?:i?gcse)\s*[:\-]?\s*(9|8|7|6|5|4|3|2|1)$/i);
  if (numericMatch) {
    const g = Number(numericMatch[1]);
    if (g >= 9) return 7;
    if (g === 8) return 6;
    if (g === 7) return 5;
    if (g === 6) return 4;
    if (g === 5) return 3;
    if (g === 4) return 2;
    if (g === 3) return 1;
    return 0;
  }

  if (s === 'Attained' || s === 'A' || s === '達標' || s === '达标') return 0;

  if (/^a\*$/i.test(s)) return 7;
  if (/^a$/i.test(s)) return 6;
  if (/^b$/i.test(s)) return 5;
  if (/^c$/i.test(s)) return 4;
  if (/^d$/i.test(s)) return 3;
  if (/^e$/i.test(s)) return 2;
  if (/^f$/i.test(s)) return 1;

  return 0;
}

/**
 * @param {Array<{ subjectCode: string, score: string }>} scores
 */
export function calculateCompetitivenessFromDseScores(scores) {
  const scoreValues = scores.map((row) => scoreToPoints(row.score));
  const totalScore = scoreValues.reduce((sum, score) => sum + score, 0);
  const sortedScores = [...scoreValues].sort((a, b) => b - a);
  const best6Score = sortedScores.slice(0, 6).reduce((sum, score) => sum + score, 0);
  const best5Score = sortedScores.slice(0, 5).reduce((sum, score) => sum + score, 0);
  const coreScore = scores
    .filter((row) => ['CHI', 'ENG', 'MAT'].includes(row.subjectCode))
    .reduce((total, row) => total + scoreToPoints(row.score), 0);

  return {
    totalScore,
    best6Score,
    best5Score,
    coreScore,
    topProgrammes: Math.min(100, Math.round((best6Score / 42) * 100)),
    competitiveProgrammes: Math.min(100, Math.round((best5Score / 35) * 100)),
    safetyProgrammes: Math.min(100, Math.round((best5Score / 25) * 100)),
  };
}
